// src/layout/AppLayout.js
import React from "react";
import SideBar from "../components/side-bar/side-bar";
import TopBar from "../components/app-header/top-bar";
import Header from "../components/app-header/Header";
import Banner from "../components/banner/Banner";
import { useStore } from "../store/store.context";
import Feedback from "../components/feedback/Feedback.js";
const AppLayout = ({ children }) => {
  const { store } = useStore();

  const showBanner = store.activeTab === 'cargo-mate' || store.activeTab === 'metrics-snapshot';
  const showFeedback = store.activeTab === 'cargo-mate';
  const tabType = store.tabTypeName
  const isCargoMateOrMetricsTab = store.activeTab === 'cargo-mate' || store.activeTab === 'metrics-snapshot';
  
  // Only apply cargo-mate-tab class when on cargo-mate tab AND showing the prompt panel (no data yet)
  const shouldApplyCargoMateMargin = store.activeTab === 'cargo-mate' && !store.apiResponseData;
  
  // Show banner for metrics-snapshot always, or for cargo-mate when no data is loaded
  const shouldShowBanner = store.activeTab === 'metrics-snapshot' || (store.activeTab === 'cargo-mate' && !tabType);
  
  return (
    <>
      {/* <TopBar/> */}
      <Header/>
      {/* <div className={`scroll-region no-banner`}> */}
        {/* <div className="mds-page"> */}
          <div className="app-layout">
            <SideBar />
            {/* <div className="main-content" style={showBanner && !tabType ? { marginTop: '190px' } : {}}></div> */}
            <div className={`main-content ${shouldShowBanner ? 'with-banner' : ''} ${shouldApplyCargoMateMargin ? 'cargo-mate-tab' : ''}`}>
              {showFeedback && !tabType && <Feedback/>}
               {shouldShowBanner && <Banner/>}
              {children}
              <div className="footerStyle">Powered by GDA </div>
              </div>
          </div>
        {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default AppLayout;
